import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'universal-cookie';
import JsCookies from 'js-cookie';

const cookies = new Cookies();

const initState = {
	userInfo: cookies?.get('user'), // for user object
	userToken: JsCookies?.get('token'),
	commentState: cookies?.get('commentState') // for storing the JWT,
};

export const authSlice = createSlice({
	name: 'auth',
	initialState: initState,
	reducers: {
		setUserInfo: (state, { payload }) => {
			state.userInfo = payload;
		},
		setCommentState: (state, { payload }) => {
			state.commentState = payload;
		}
	}
});

export const { setUserInfo, setCommentState } = authSlice.actions;

export default authSlice.reducer;
